import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ScheduleComponent } from '../../../../Alsa-MA-Angular-administrar-tarjetas/src/app/DTOs/Schedule.component';
import { Calendar } from 'primeng/calendar';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var portletNameCardRequestLiferay: any; // Nombre del portlet en Liferay
declare var GetCityAgencies: any; // URL para obtener las agencias disponibles
declare var GetDelivery: any; // URL para obtener los días disponibles para recojer las tarjetas en la agencia seleccionada
declare var GetScheduleOcupation: any; // URL para obtener los horarios disponibles
declare var GetScheduleOcupationCalendar: any; // URL para obtener los horarios no disponibles
declare var i18nVS: any;
declare var isSignedIn: any;

/*--------------------------------------------- Variables Globales ---------------------------------------------*/
const DEFAULT_LOCALE = "fr";

@Component({
    selector: 'app-make-appointment',
    templateUrl: './makeAppointment.component.html',
    styleUrls: ['../solicitud-tarjeta.component.css']
})

export class MakeAppointmentComponent implements OnInit {
    SELECT_LOADING_VALUE = "-2";
    SELECT_NONE_VALUE = "-1";

    inputErrorClass = "inputError";

    i18nL = i18nVS;
    portletName = ''; // Nombre del portlet
    cardRequest = null;

    jsonData = null;
    agencies = [];
    deliveries = [];
    schedule = [];

    @Output() onWebServiceError: EventEmitter<string> = new EventEmitter<string>();
    @Output() onSubmitAppointmentForm: EventEmitter<string> = new EventEmitter<string>();
    @Output() onGeneralError: EventEmitter<string> = new EventEmitter<string>();
    @Input() languageId: string;
    @Input() maxDateInMilis: number;

    // Validaciones
    fechaClass = '';
    fechaUnworkableClass = 'invisible';
    fechaNotReadyClass = "invisible";
    agencyClass = '';

    calendarDisabled: boolean = false;
    scheduleDisabled: boolean = false;
    agencyDisabled: boolean = false;

    cargandoAgencias = true;

    noHayHorariosErrorClass = 'invisible';

    // Agencia actualmente seleccionada
    agencySelected = "";

    spinnerClass = 'invisible';

    agencyId = '';
    heureId = '';

    // Si es la primera vez que se cargan estos valores
    firstLoad = true;

    runClearClass = true;

    inputSchedule: HTMLInputElement;
    inputAgency: HTMLInputElement;

    // PrimeNG - Calendario
    @ViewChild("calendar") calendar: Calendar;
    locale: string;
    selectedDate: Date;
    // Controlamos las fechas minimas y maximas para pedir una cita
    maxAppointmentDate = new Date();
    minAppointmentDate = new Date();
    disabledDates: Array<Date> = new Array<Date>();

    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    /**
     * Funcion para cargar datos que son necesarios cargar desde el exterior
     * @param requestURL url para obtener la información
     * @param fileData Nobre del fichero de respaldo con los datos
     */
    private readData(requestURL: string): Observable<Response> {
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }); // ... Set content type to JSON
        const options = new RequestOptions({ headers: headers }); // Create a request option
        return this.http.post(requestURL, "", options);
    }

    /**
     * Procesa errores detectados en el formato JSON
     */
    private errorEnElJson(err: string, res: Response) {
        console.log('Error en los WS: ' + err);
        if (res != null) {
            console.log(res);
        }
        this.onWebServiceError.emit(err);
    }

    /**
     * valida objetos JSON
     * @param res recurso a validar
     */
    private validateJSON(res) {
        try {
            this.jsonData = res.json();
        } catch (error) {
            this.errorEnElJson('Error al comprobar el JSON', res);
        }
    }

    /**
     * Inicializa los select con las agencias
     */
    private initSelectAgencies() {
        this.spinnerClass = '';
        this.readData(GetCityAgencies).subscribe(
            res => this.validateJSON(res),
            (err) => this.errorEnElJson(err, null),
            () => { this.initAgencies(), this.spinnerClass = 'invisible' }
        );
    }

    /**
     * Inicializa las agencias disponibles
     */
    private initAgencies() {
        for (var i = 0; i < this.jsonData.length; i++) {
            if (this.jsonData[i].active) {
                this.agencies.push(this.jsonData[i]);
            }
        }
    }

    public deliveryNotReady() {
        if (this.agencies == []) {
            this.fechaNotReadyClass = "error";
        }
    }

    // Cargamos los dias en los que se puede seleccionar una cita
    public loadDelivery(agencyId) {
        this.selectedDate = null;
        this.inputSchedule.value = null;
        this.agencySelected = (typeof agencyId == 'undefined') ? this.inputAgency.value : agencyId;
        this.cargandoAgencias = false;
        if (this.agencySelected != "") {
            if ((this.agencySelected == null) || (this.agencySelected == '')) {
                return;
            }
            this.initDateDelivery(this.agencySelected);
        }
    }

    private initDateDelivery(agencyId: string) {
        var urlFinal = GetDelivery + "&" + this.portletName + "agencyId=" + agencyId;
        this.spinnerClass = '';
        this.readData(urlFinal).subscribe(
            res => this.validateJSON(res),
            (err) => this.errorEnElJson(err, null),
            () => { this.initDelivery(), this.spinnerClass = 'invisible' }
        );
    }

    /**
     * Inicializa los horarios disponibles
     */
    private initDelivery() {
        this.deliveries = this.jsonData;
        // Quitar cualquier mensaje de error que se estuviera mostrando
        this.noHayHorariosErrorClass = 'invisible';

        if (this.deliveries.length) {
            this.calendarDisabled = false;
            if (this.selectedDate != null) {
                this.loadSchedule();
            }
        } else { // En caso de que no haya horarios para esta fecha
            this.noHayHorariosErrorClass = 'error';
        }
    }

    public loadSchedule() {
        var agencyId = this.inputAgency.value

        if (this.selectedDate == undefined || this.selectedDate == null || agencyId == null || agencyId == '') {
            this.selectedDate = null;
            return;
        }
        this.initSelectSchedule(new Date(this.selectedDate), agencyId);

        this.disableFieldsIfPastDueDate();
    }

    private initSelectSchedule(date: Date, deliveryId: string) {
        var urlFinal = GetScheduleOcupation + "&" + this.portletName + "date=" + date.toISOString() + "&" + this.portletName + "deliveringId=" + deliveryId
        this.spinnerClass = '';
        this.readData(urlFinal).subscribe(
            res => this.validateJSON(res),
            (err) => this.errorEnElJson(err, null),
            () => { this.initSchedule(), this.spinnerClass = 'invisible' }
        );
    }

    // Valida si se debe habilitar la edición de los campos de la cita. Si estamos editando se comprueba si la fecha de la cita ya ha pasado.
    private disableFieldsIfPastDueDate() {

        if (isSignedIn) {
            this.calendarDisabled = this.selectedDate <= new Date()
            this.scheduleDisabled = this.calendarDisabled;
            this.agencyDisabled = this.calendarDisabled;
        }
    }

    private clearSchedule() {
        if (this.schedule.length == 0) {
            return;
        }

        while (this.schedule.length > 0) {
            this.schedule.pop();
        }
    }

    /**
     * Inicializa los horarios disponibles
     */
    private initSchedule() {
        this.clearSchedule();
        this.runClearClass = true;

        for (let i = 0; i < this.jsonData.length; i++) {
            var currentSchedule = ScheduleComponent.fromJSON(this.jsonData[i]);
            if (currentSchedule != null && currentSchedule.actualOccupation < currentSchedule.maxOccupation) {
                this.schedule.push(currentSchedule);
            }
        }

        // Comprobamos si no hay ningun horario disponible para la fecha dada
        if (this.schedule.length == 0) {
            this.noHayHorariosErrorClass = 'error';
        } else {
            this.noHayHorariosErrorClass = 'invisible';
        }
    }

    public validateAppointmentForm() {
        var valid = true;
        this.onGeneralError.emit("");
        if (!this.isMandatory(this.inputAgency)) {
            valid = false;
        }
        if (this.selectedDate == undefined || this.selectedDate == null) {
            valid = false;
        }
        if (!this.isMandatory(this.inputSchedule)) {
            valid = false;
        }
        return valid;
    }

    // Retorna true si es correcto y false si esta mal
    public isMandatory(input) {
        var valorActualDelInput = input.value.trim();
        if (valorActualDelInput !== '' && valorActualDelInput != this.SELECT_NONE_VALUE
            && valorActualDelInput != this.SELECT_LOADING_VALUE) {
            input.classList.remove(this.inputErrorClass)
            return true;
        } else {
            input.classList.add(this.inputErrorClass);
            if (typeof input.placeholder != 'undefined') {
                input.placeholder = this.i18nL.form_campoObligatorio;
            }
            this.onGeneralError.emit(this.i18nL.form_required_field);
            return false;
        }
    }

    public onSelect() {
        console.log("Pruebas de lanzamiento de evento onSelect");
    }

    public currentDate() {
        return new Date(Date.now());
    }

    public isVisibleSchedule(schedule) {
        return (schedule.getActualOccupation() < schedule.getMaxOccupation()) ? '' : 'invisible';
    }

    // En caso de que un usuario logueado y ya tuviese el formulario relleno se le permitira pedir una cita
    public mostrarEstaSeccion(cardRequest) {
        this.cardRequest = cardRequest;
        this.agencyId = this.cardRequest.agence;
        this.heureId = this.cardRequest.heure;
        this.runClearClass = false;
        this.loadDelivery(this.agencyId);


        // Load of the appointment data
        this.selectedDate = new Date(this.cardRequest.daterdv);
        this.inputSchedule.value = this.heureId;

        this.firstLoad = true;
    }

    public submitAppointmentForm() {
        this.onSubmitAppointmentForm.emit("submitAppointment");
    }

    // Al seleccionar agencia cargamos los dias en los que NO se puede seleccionar una cita
    public loadUnavailableDates(selectedAgencyId: string) {
        this.calendarDisabled = (selectedAgencyId == "" || selectedAgencyId == this.SELECT_NONE_VALUE);
        this.scheduleDisabled = this.calendarDisabled;

        this.selectedDate = null;
        this.inputSchedule.value = null;
        this.cargandoAgencias = false;
        if (!this.calendarDisabled) {
            this.disabledDates = new Array<Date>();
            this.getUnavailableDates(this.minAppointmentDate, this.maxAppointmentDate, selectedAgencyId);
        }
    }

    /**
    * Devuelve el los días en los que no se pueden coger citas
    * La fecha de inicio será la actual y la de fin será un año mas tarde.
    */
    private getUnavailableDates(dateStart, dateEnd, agencyId) {
        var urlFinal = GetScheduleOcupationCalendar + "&" + this.portletName + "fechaFin=" + dateEnd.toISOString() + "&" + this.portletName + "fechaInicio=" + dateStart.toISOString() + "&" + this.portletName + "agencyId=" + agencyId;
        this.spinnerClass = '';
        this.readData(urlFinal).subscribe(
            res => this.validateJSON(res),
            (err) => this.errorEnElJson(err, null),
            () => { this.initUnavailableDates(), this.spinnerClass = 'invisible' }
        );
    }

    /**
     * Inicializa los dias NO disponibles
     */
    private initUnavailableDates() {
        for (var i = 0; i < this.jsonData.fecha.length; i++) {
            var unavailableDate = new Date(this.jsonData.fecha[i]);
            this.disabledDates.push(unavailableDate);
        }

        // Force calendar update. We need to do this manually, because of the disabled option in the component.
        // When this gets updated the component isn't properly re-rendered and the disabled days aren't shown.
        this.calendar.updateUI();
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameCardRequestLiferay;
        this.schedule = [];
        this.deliveries = [];
        this.agencies = [];
        this.initSelectAgencies();

        // PrimeNG - Gestión de fechas seleccionables
        this.maxAppointmentDate = new Date(Number(this.maxDateInMilis));
        this.initLocales();
    }

    /*
    * Inicializa los valores para los diferentes locales y selecciona el correspondiente para el
    * LanguageId recibido, asignando el inglés por defecto.
    */
    initLocales() {
        let locales = {
            en: {
                firstDayOfWeek: 0,
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                dateFormat: "mm/dd/yy",
                today: "Today",
                clear: "Clear"
            }, fr: {
                firstDayOfWeek: 1,
                dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
                monthNames: ["Janvier", "Fevrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"],
                monthNamesShort: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun", "Jul", "Aou", "Sep", "Oct", "Nov", "Dec"],
                dateFormat: "dd/mm/yy",
                today: "Aujourd\'hui",
                clear: "Dégager"
            }, ar: {
                firstDayOfWeek: 0,
                closeText: "إغلاق", prevText: "&#x3C;السابق", nextText: "التالي&#x3E;", currentText: "اليوم",
                dayNamesShort: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
                dayNamesMin: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
                monthNames: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
                monthNamesShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                dayNames: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
                dateFormat: "dd/mm/yy",
                today: "اليوم",
                clear: "محو"
            }
        };

        this.locale = locales[this.languageId];
        if (this.locale == undefined) {
            this.locale == DEFAULT_LOCALE;
        }
       
    }

    ngAfterViewChecked() {
        // Recogemos todos los inputs
        this.inputSchedule = (<HTMLInputElement>document.getElementById(this.portletName + 'schedule'));
        this.inputAgency = (<HTMLInputElement>document.getElementById(this.portletName + 'agency'));
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private http: Http) { }
}



// WEBPACK FOOTER //
// ./src/app/makeAppointment/makeAppointment.component.ts